import {
  Box,
  Container,
  Heading,
  Text,
  VStack,
  SimpleGrid,
  Image,
  useColorModeValue,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
} from "@chakra-ui/react";
import { useState } from "react";

interface TeamMember {
  name: string;
  title: string;
  avatar: string;
  bio: string;
}

const teamMembers: TeamMember[] = [
  {
    name: "علی پازکی",
    title: "مدیرعامل",
    avatar: "/images/team-photos/علی پازکی.jpg",
    bio: "مدیرعامل",
  },
  // {
  //   name: "محمد ابراهیم راعی عزآبادی",
  //   title: "رئیس هیئت مدیره",
  //   avatar: "/images/team-photos/راعی.png",
  //   bio: "رئیس هیئت مدیره شرکت تأمین سرمایه امید",
  // },
  // {
  //   name: "محمد غواصی کناری",
  //   title: "عضو هیئت مدیره",
  //   avatar: "/images/team-photos/محمد غواصی.png",
  //   bio: "عضو هیئت مدیره شرکت تأمین سرمایه امید",
  // },
  {
    name: "سید محمدجواد فرهانیان",
    title: "عضو هیئت مدیره",
    avatar: "/images/team-photos/فرهانیان.png",
    bio: "عضو هیئت مدیره شرکت تأمین سرمایه امید",
  },
  {
    name: "نوید رفیعی تبریزی",
    title: "عضو هیئت مدیره",
    avatar: "/images/team-photos/نوید رفیعی.png",
    bio: "عضو هیئت مدیره شرکت تأمین سرمایه امید",
  },
];

export const SectionTeam = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [selected, setSelected] = useState<TeamMember | null>(null);
  const teamMemberCount = teamMembers.length;

  const headingColor = useColorModeValue("gray.900", "white");
  const textColor = useColorModeValue("gray.600", "gray.300");
  const cardBg = useColorModeValue("white", "dark.300");
  const borderColor = useColorModeValue("gray.200", "gray.700");
  const modalBg = useColorModeValue("white", "dark.200");
  const avatarBg = useColorModeValue("brand.50", "brand.200");

  const handleClick = (member: TeamMember) => {
    setSelected(member);
    onOpen();
  };

  return (
    <Box>
      <Container maxW="container.xl">
        <VStack spacing={8} align="stretch">
          <VStack spacing={3} align="center" textAlign="center">
            <Heading
              as="h2"
              fontSize={{ base: "xl", md: "2xl", lg: "3xl" }}
              fontWeight="bold"
              color={headingColor}
            >
              مدیریت و تیم رهبری
            </Heading>
            <Text fontSize={{ base: "sm", md: "md" }} color={textColor}>
              تیمی متخصص و باتجربه در خدمت شما
            </Text>
          </VStack>

          <SimpleGrid
            columns={{
              base: Math.min(2, teamMemberCount),
              sm: Math.min(3, teamMemberCount),
              lg: Math.min(5, teamMemberCount),
            }}
            spacing={4}
            justifyItems="center"
            justifyContent="center"
            w="fit-content"
            maxW="100%"
            mx="auto"
          >
            {teamMembers.map((member) => (
              <Box
                key={member.name}
                bg={cardBg}
                borderRadius="xl"
                border="1px solid"
                borderColor={borderColor}
                overflow="hidden"
                cursor="pointer"
                w="100%"
                maxW="220px"
                onClick={() => handleClick(member)}
                _hover={{
                  shadow: "md",
                  borderColor: "brand.200",
                  transform: "translateY(-4px)",
                }}
                transition="all 0.3s"
              >
                {member.avatar ? (
                  <Image
                    src={member.avatar}
                    alt={member.name}
                    w="100%"
                    aspectRatio={1}
                    objectFit="cover"
                  />
                ) : (
                  <Box
                    w="100%"
                    aspectRatio={1}
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    bg={avatarBg}
                  >
                    <Text fontSize="3xl" fontWeight="bold" color="brand.500">
                      {member.name.charAt(0)}
                    </Text>
                  </Box>
                )}
                <VStack spacing={0.5} py={3} px={2}>
                  <Text
                    fontSize="sm"
                    fontWeight="bold"
                    color={headingColor}
                    textAlign="center"
                  >
                    {member.name}
                  </Text>
                  <Text fontSize="xs" color={textColor} textAlign="center">
                    {member.title}
                  </Text>
                </VStack>
              </Box>
            ))}
          </SimpleGrid>
        </VStack>
      </Container>

      {/* Bio Modal */}
      <Modal isOpen={isOpen} onClose={onClose} isCentered size="sm">
        <ModalOverlay backdropFilter="blur(4px)" />
        <ModalContent dir="rtl" borderRadius="xl" bg={modalBg}>
          <ModalCloseButton />
          <ModalHeader fontSize="md">{selected?.name}</ModalHeader>
          <ModalBody pb={6}>
            {selected?.avatar ? (
              <Image
                src={selected.avatar}
                alt={selected.name}
                w="100%"
                aspectRatio={1}
                objectFit="cover"
                borderRadius="xl"
                mb={4}
              />
            ) : null}
            <Text fontSize="sm" fontWeight="bold" color="brand.500" mb={2}>
              {selected?.title}
            </Text>
            <Text fontSize="sm" color={textColor} lineHeight="1.8">
              {selected?.bio}
            </Text>
          </ModalBody>
        </ModalContent>
      </Modal>
    </Box>
  );
};
